<template>
<div class="tweet-box">
  <Tweet :tweet_info="tweet_info"/>
  <div class="columns is-gapless is-mobile">
    <div class="column category_box" v-bind:class="{'has-background-light': !is_registed, 'has-background-success': is_registed}">
      <p style="margin:auto;" v-bind:class="{'has-text-grey': !is_registed, 'has-text-white': is_registed}">
        {{registered_list_name}}
      </p>
    </div>
    <div class="column is-narrow">
      <div class="button is-danger" @click="is_modal_open=true">ストックする</div>
    </div>
  </div>
  <MylistModal :tweet_id="tweet_info.id" v-model="is_modal_open" @add-tweet="$emit('tweet-regist')"/>
</div>
</template>

<script>
import MylistModal from '@/components/MylistModal.vue'
import Tweet from '@/components/OriginalEmbededTweet.vue'

export default {
  components: {
    MylistModal,
    Tweet,
  },
  props: ['tweet_info'],
  data() {
    return {
      is_modal_open: false
    }
  },
  computed: {
    registered_list_name() {
      return this.is_registed ? this.tweet_info.registeredListname : "未分類"
    },
    is_registed() {
      if(this.tweet_info.registeredListname == undefined) return false
      if(this.tweet_info.registeredListname == "") return false
      return true
    }
  }
}
</script>

<style lang="scss">
.tweet-box {
  max-width: 400px;
	margin-left: auto;
	margin-right: auto;
  margin-top: 1em;
  margin-bottom: 1em;
  border: solid;
  border-width: 1px;
  border-color: #eee;
}
.category_box {
  max-height: 36px;
  border: solid;
  border-width: 1px;
  border-color: #eee;
	display: flex;
	align-items: center;
}
</style>